export default __webpack_public_path__ + "static/cp-app-screens-next-mobile-d6570d783da9328f451795d87308d7dd.jpg";